import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// 📱 Register the PWA service worker so the app is installable on
// Android / iOS / Desktop and works offline. Skipped on localhost
// only when hot-reload dev seems flaky; production preview + deploy
// register it eagerly. SW code lives at /public/sw.js.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch((err) => {
        // Swallow — SW failures should never break the app.
        console.warn("[PWA] service worker registration failed:", err);
      });
  });

  // 🔁 Web↔mobile parity: when a newly-activated SW evicts a stale
  // cache version it broadcasts { type: "SW_REFRESH" } to every live
  // tab so Roc's phone (and any other PWA install) auto-reloads into
  // the fresh bundle without the user having to clear app data.
  // We guard with sessionStorage so a boot-loop is impossible — one
  // auto-reload per tab session, nothing more.
  navigator.serviceWorker.addEventListener("message", (ev) => {
    const data = ev && ev.data;
    if (!data || data.type !== "SW_REFRESH") return;
    try {
      if (sessionStorage.getItem("__sw_refresh_done") === "1") return;
      sessionStorage.setItem("__sw_refresh_done", "1");
    } catch {}
    try { window.location.reload(); } catch {}
  });
}
